import useMultiSite from './use-multi-site'
import {useQuery} from '@tanstack/react-query'
const getLocale = (locale) => import(`date-fns-locale/locale/${locale}.js`)

const useDateFnsLocale = () => {
    const {locale} = useMultiSite()

    return useQuery({
        queryKey: ['app', 'date-fns', 'locale', locale?.dateFns],
        queryFn: async () => {
            const {default: localeData} = await getLocale(locale.dateFns)
            return localeData
        },
        enabled: !!locale?.dateFns
    })
}

export default useDateFnsLocale
